import { EntryType } from "@/data/directoryTypes";

interface TypeBadgeProps {
  type: EntryType;
}

const typeColors: Record<EntryType, string> = {
  Regulator: "bg-foreground/10 text-foreground border-foreground/20",
  "Regional Entity": "bg-silver-light text-secondary-foreground border-silver/30",
  ISAC: "bg-primary/10 text-primary border-primary/20",
  Standard: "bg-foreground/10 text-foreground border-foreground/20",
  Product: "bg-primary/15 text-primary border-primary/25",
  Consultant: "bg-secondary text-secondary-foreground border-border",
  Training: "bg-primary/10 text-primary border-primary/20",
  Influencer: "bg-foreground/8 text-foreground border-foreground/15",
  Event: "bg-primary/10 text-primary border-primary/20",
  Procurement: "bg-silver-light text-secondary-foreground border-silver/30",
  Reference: "bg-secondary text-secondary-foreground border-border",
};

const TypeBadge = ({ type }: TypeBadgeProps) => {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border ${typeColors[type]}`}>
      {type}
    </span>
  );
};

export default TypeBadge;
